import { AxiosResponse } from 'axios'
import { ServiceConfig } from 'shared/services/ServiceConfig'

import ICidadeResponse from '../../domain/entities/CidadeResponse'
import { ICidadeRepository } from '../../domain/repositories/ICidadeRepository'

const http = new ServiceConfig()
export default class CidadeRepository implements ICidadeRepository {
  public async findByNome(cidade: string): Promise<ICidadeResponse> {
    const response: AxiosResponse<ICidadeResponse> = await http.get(
      `/cidades?nome=${cidade}`,
    )
    return response.data
  }
}
